export default __webpack_public_path__ + "static/media/Error_Yellow.7f908935.svg";